var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown",on:{"mouseover":_vm.onHover,"mouseleave":_vm.onLeave}},[_vm._t("header"),_vm._v(" "),(_vm.display)?_c('section',{staticClass:"dropdown__menu"},[_c('div',{staticClass:"dropdown__buffer"}),_vm._v(" "),_c('div',{staticClass:"dropdown__slot"},[_vm._t("dropdown")],2)]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }